export const ERROR_MESSAGES = {
    PASSWORD_CHANGE_ERROR: 'An error occurred while changing your password. Please try again.',
    USER_NOT_FOUND_ERROR: 'User information not found. Please try logging in again.',
    USER_DETAILS_LOAD_ERROR: 'An error occurred while loading user details. Please try again later.',
};

export const SUCCESS_MESSAGES = {
    PASSWORD_CHANGE_SUCCESS: 'Your password was changed!',
};
